import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { ResetPasswordContainer } from "../components/ResetPassword/ResetPasswordContainer";

type Props = {
  onError?: () => void;
};

export function ResetPasswordPage({ onError }: Props) {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const oobCode = searchParams.get("oobCode");

  const onCancel = () => {
    navigate("/login");
  };

  return (
    <ResetPasswordContainer
      onCancel={onCancel}
      oobCode={oobCode}
      onError={onError}
    />
  );
}

export default ResetPasswordPage;
